import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { UseQueryCustomOptions } from "app/types/application-types";
import SysTable from "app/class/sys-table";
import { RecordManagement } from "app/class/record-management";
import metadataQueryKeys from "shared/services/metadataQueryKeys";

export const fetchTables = () =>
    new RecordManagement<SysTable>("sys_tables").paginate(1, 2000).orderBy("created_at").run();

export const useTables = (options?: UseQueryCustomOptions) => {
    const query = useQuery({
        queryKey: metadataQueryKeys.tables,
        queryFn: fetchTables,
        // prevent refetching unnecessarily
        staleTime: 1000 * 60 * 5, // 5 minutes
        ...options
    });

    const data = useMemo(
        () => query.data?.data.map((item: any) => new SysTable(item)) ?? [],
        [query.data?.data]
    );

    return {
        ...query,
        data,
    };
};
